import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { EagerSelectEffects } from '../../select/eager-select/eager-select-effects';
import { roleOptionActions } from './role-option.actions';
import { roleOptionSelectors } from './role-option.reducer';

@Injectable({ providedIn: 'root' })
export class RoleOptionEffects {
   defaultFields: string[] = ['name', 'roleId'];

   defaultOrderingOptions: string[] = ['name:asc'];

   staticFilters: string[] = [];

   load = this.eagerSelectEffects.createEagerSelectorLoadEffect(
      roleOptionSelectors.selectState,
      'roles',
      this.defaultFields,
      this.defaultOrderingOptions,
      roleOptionActions,
      this.staticFilters
   );

   constructor(private eagerSelectEffects: EagerSelectEffects<AppState>, private store: Store) {}
}
